<template>
  <div>
    <commBanner :obj="obj" navType="4"></commBanner>
     <titleHead :headTitle="obj.title" :headText="obj.content"></titleHead>
     <div class="summary_box warp">
       <!--左边-->
        <div class="summary_left">
             <!--搜索-->
            <div class="search_box">
              <div class="search_input">
               <input  type="text" v-model="keyword" placeholder="请输入你要查询的关键字"/>
               <button @click="getList()"><img src="@/assets/images/search.png" alt="" /></button>
             </div>
           <!-- <div class="search_keywords">
            <span>关键字:</span>
            <span @click="setKeyword(item)" v-for="(item, index) in keyswordList"
                :key="index"
                >{{ item.name }}</span>
            </div> -->
            </div>


            <!--分类-->
            <div class="news_item_nav">
              <ul>
                <li
                  :class="categoryId == index + 1 ? 'active' : ''"
                  v-for="(item, index) in categoryList"
                  :key="index"
                  @click="navChange(index,item)"
                  @mouseenter="mouseover(index,item)"
                  @mouseleave="mouseLeave(item)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </div>


            <!--列表-->
            <div class="summ_coment">
                <div class="summ_box">
                    <div class="summ_messsage" v-for="(item,index) in demandList " :key="index" @click="goDetail(item)">
                        <p class="summ_message_titlle">{{item.title}}</p>
                        <p class="summ_message_tetx" v-if="item.userloctionstr">位置：{{item.userloctionstr.replace(/,/g, "/")}}</p>
                        <p class="summ_message_tetx">发布时间：{{item.createDate}}</p>
                    </div>
                </div>
 
        <!--分页-->
        <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>
            </div>
        </div>
       <!--右边-->
       <div class="summary_right">
          <!--广告-->
          <div class="find_right" v-if="advList.length>0">
            <a :href="'//'+advList[0].url" target="_blank">
                <img :src="advList[0].image" alt="" />
                <span>广告</span>
            </a>
          </div>
          <!--推荐产品-->
           <prodRecommend
            v-if="productList.length > 0"
            @reload="randomProduct"
            :list="productList"
            style="margin-top: 20px"
          ></prodRecommend>


       </div>
     </div>

  </div>
</template>
<script>
import commBanner from "../../common/commBanner";
import Pagination from '../../components/Pagination'
import titleHead from "../../common/titleHead";
import prodRecommend from "../../common/prodRecommend";
import {routerGoNewpage,getRandomArray} from "@/utils/index"
import {getDemandList,getAdv,getProduct,getDemandRecruitList} from "@/api/information"
export default {
    components:{commBanner,Pagination,titleHead,prodRecommend},
    data(){
      return{
         obj:{
            title: "平台需求",
            roleType:'',
            personalType:4,
         },
         listQuery:{
           curPage: 1,
           limit: 5
         },
         total:0,//当前条数
         demandList:[], // 需求列表
         advList: [], // 广告列表
         productList: [], //产品列表
         allProductList:[], //总产品列表
         advType: 6,
         keyword:'',
         categoryId: 1,   // 需求类型初始值
         categoryList: [
            {
              label: "平台需求",
              id: 1
            },
            {
              label: "人力资源",
              id: 2
            }
         ]
        }
    },
    created(){
      this.getList(this.categoryId);
      this.getAdvList();
      this.getProductList();
      this.getMate();
    },
    methods:{
       //获取列表
       getList(id){
        if(id == 2){
          getDemandRecruitList({
            ...this.listQuery,
              keyword:this.keyword,
              recommend: 1
         }).then((res)=>{
           if(res.code == 0){
              this.demandList = res.page.list;
              this.total = res.page.totalCount;
           }
         }).catch((err)=>{})
        }else{
          getDemandList({
         ...this.listQuery,
          keyword:this.keyword,
          recommend: 1
         }).then((res)=>{
           if(res.code == 0){
              this.demandList = res.data.list;
              this.total = res.data.totalCount;
           }
         }).catch((err)=>{})
        }
       },
       //详情
       goDetail(data){
         routerGoNewpage('/demand_detail',{id:data.id,type:this.categoryId})
       },
       pageChange(data){
            this.listQuery['curPage'] = data.page;
            this.listQuery['limit'] = data.limit;
            this.getList();
       },
       //获取广告
       getAdvList(){
           getAdv({
            curPage: 1,
            limit: 10,
            type: this.advType,
           }).then((res)=>{
              if(res.code == 0){
                this.advList = res.page.list;
              }
           }).catch((err)=>{})
       },
       //获取产品列表
       getProductList(){
        getProduct({
          curPage: 1,
          limit: 10,
          recommend: 1,
        }).then((res)=>{
          if(res.code == 0){
            this.allProductList = res.page.list;      
            this.randomProduct();
          }
        }).catch((err)=>{})
       },
       //推荐产品 随机取4个
      randomProduct() {
        this.productList = this.randomList(this.allProductList, 3);
      },
      randomList(list, length) {
        return _.compact(getRandomArray(_.cloneDeep(list), length));
      },
     getMate(){
      var metas = document.getElementsByTagName("meta"); 
      document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
     },

      // 类型点击事件
     	navChange(index,item){
        // this.categoryId = item.id
        console.log("需求点击事件",item.id)
        // this.current = index;
        // this.currentType = item.id;
        this.getList(item.id);
        console.log(this.demandList)
      },

       //移入移出事件
      mouseover(index,data){
        this.$nextTick(()=>{
          // this.current = index;
          this.categoryId = data.id;
          this.listQuery.curPage =1;
          this.total = 0;
          this.getList(this.categoryId);
          this.$set(data,'show',true)
        });
        },
      mouseLeave(data){
          this.$set(data,'show',false)
      },
    }
}

// <style  scoped="scoped">
</script>
<style  scoped lang="less">
.summ_coment{
    margin-top:20px;
    /* width: 80%;
    margin: 0 auto; */
}
.summ_messsage{
    width: 100%;
    transition: all 0.5s;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 110px;
    margin-top: 20px;
    background: #f8f8f8;
    padding: 15px;
    border-radius: 5px;
    padding: 10px 20px;
}
.summ_messsage:hover{
    box-shadow: 0 0 20px #ddd;
}
.summ_messsage p{
   margin: 4px 0px;
}
.summ_message_titlle{
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.summ_message_tetx{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
}
.summary_box{
  display: flex;
  justify-content: space-between;
 /* width: 71%; */
  margin: 0 auto;
}
.summary_left{
   width: 70%;
}
.search_input{
    display: flex;
}
.search_input input{
    flex: 7;
    border: 1px solid #65b62b;
    border-right: none;
    padding: 16px;
}
.search_input button{
    padding: 0 34px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    background: #3bae30;
}
.search_input button img{
    width: 21px;
    height: 21px;
}
.summary_right{
  width: 28%;
}




/***广告 */
.find_right {
  position: relative;
  margin-bottom: 10px;
}
.find_right img {
  width: 100%;
  height: 184px;
}
.find_right span {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.pagination-container{
    margin-top: 30px;
}
.news_item_nav {
  margin-top: 20px;
  line-height: 62px;
  background: url("../../assets/images/bg_8.jpg") no-repeat center/cover;
  ul {
    display: flex;
    padding: 0 30px;
    li {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 24px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .active {
      position: relative;
      &::after {
        position: absolute;
        bottom: 10px;
        left: 0;
        display: inline-block;
        content: "";
        width: 100%;
        height: 2px;
        background: #ffffff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/other/summary_demand.vue